<script setup lang="ts">
/** One chapter's form: no layout, CTA, last-screen toggle or activities — the passage is the form. */
import { AppText } from '@shared/ui/typography'

import { useChapterEditor } from '../../../model/assignments/chapter-editor.hook'
import ChapterContentList from './ChapterContentList.vue'

defineOptions({
  name: 'ChapterEditor',
})

const {
  refOwner,
  refLabel,
} = useChapterEditor()
</script>

<template>
  <div class="chapter-editor">
    <AppText
      v-if="!refOwner"
      name="body2"
      color="slate-500"
    >
      Select a chapter to write it.
    </AppText>

    <template v-else>
      <AppText name="body1-medium">
        {{ refLabel }}
      </AppText>

      <!-- The reused list, addressed by the chapter's own id. `label` is the copy-neutrality prop
           the original already carried; nothing else needed one. -->
      <ChapterContentList
        :owner="refOwner"
        label="Chapter content"
      />
    </template>
  </div>
</template>

<style scoped lang="scss" src="./ChapterEditor.scss" />
